//libraries
import Vue from 'vue'
import axios from 'axios'

let resource = 'knowledge'
let resource_name = 'conocimiento'
let resource_name_plural = 'conocimiento'

let state = {

}

state[resource] = []

//functions receive state
let getters = {

}

//functions receive context and params
let actions = {
  async all ({ commit }, params) {
    try {
      commit('setItems', [])
      let res = await Vue.request.get(`account/${params.account_id}/${resource}`, {params: params.params || {}})
      if(res.data.success) {
        res.data.resource.forEach(k => {
          delete k.refresh_token
          delete k.api_token
        })
        commit('setItems', res.data.resource)
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name_plural}.`})
      console.error(e)
    }
  },
  async get ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
  async create ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}`, params)
      if(res.data.success && params.callback) {
        commit('pushItem', res.data.resource)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando ${resource_name}.`})
      console.error(e)
    }
  },
  async update ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}`, params)
      if(res.data.success && params.callback) {
        commit('updateItem', res.data.resource)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  },
  async destroy ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`${resource}/${params[resource + '_id']}`, {data: params})
      if(res.data.success && params.callback) {
        commit('removeItem', params)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando ${resource_name}.`})
      console.error(e)
    }
  },
  async showMany ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/showMany`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo frases de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo frases de ${resource_name}.`})
      console.error(e)
    }
  },
  async addSentence ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/sentence`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error agregadno frase de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error agregando frase a  ${resource_name}.`})
      console.error(e)
    }
  },
  async updateSentence ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}/sentence`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando frase de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando frase a  ${resource_name}.`})
      console.error(e)
    }
  },
  async deleteSentence ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`${resource}/${params[resource + '_id']}/sentence`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando frase de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando frase a  ${resource_name}.`})
      console.error(e)
    }
  },
  async learn ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/learn`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error entrenando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error entrenando ${resource_name}.`})
      console.error(e)
    }
  },
  async feed ({commit}, params) {
    try {
      let res = await Vue.request.get(`account/${params.account_id}/${resource}/feed`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo base ${resource_name}.`})
      }
    }catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo base ${resource_name}.`})
      console.error(e)
    }
  },
  async feedDefault ({commit}, params) {
    try {
      let res = await Vue.request.get(`account/${params.account_id}/${resource}/default`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name} default.`})
      }
    }catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name} default.`})
      console.error(e)
    }
  },
  async feedValidated ({commit}, params) {
    try {
      let res = await Vue.request.get(`account/${params.account_id}/${resource}/default/validated`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name} validado.`})
      }
    }catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name} validado.`})
      console.error(e)
    }
  },
  async learnAll ({commit}, params) {
    try {
      let res = await Vue.request.post(`account/${params.account_id}/${resource}/learn`, params, {params: params.query || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error recabando ${resource_name}.`})
      }
    }catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error recabando ${resource_name}.`})
      console.error(e)
    }
  },
  async trainingStatus ({commit}, params) {
    try {
      let res = await Vue.request.get(`account/${params.account_id}/${resource}/status`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo el status de  ${resource_name}.`})
      }//14db0
    }catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo el status de ${resource_name}.`})
      console.error(e)
    }
  }
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state[resource] = items
  },
  pushItem (state, item) {
    state[resource].push(item)
  },
  updateItem (state, item) {
    let index = state[resource].findIndex(i => i[resource + '_id'] == item[resource + '_id'])
    if(index >= 0) {
      state[resource].splice(index, 1, item)
    }
  },
  removeItem (state, item) {
    let index = state[resource].findIndex(i => i[resource + '_id'] == item[resource + '_id'])
    if(index >= 0) {
      state[resource].splice(index, 1)
    }
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}
